import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';

const Footer = ({ onBookDemo }) => {
  return (
    <footer className="site-footer">
      <Container>
        <Row className="site-footer__top align-items-center gy-4">
          <Col xs={12} md="auto">
            <a href="/" className="site-footer__brand" aria-label="Lien Logic home">
              <img
                src="/images/logoFooter.svg"
                alt="Lien Logic — Negotiate smarter. Recover more."
                className="site-footer__logo"
              />
            </a>
          </Col>

          <Col xs={12} md>
            <Nav className="site-footer__nav justify-content-md-end flex-wrap">
              <Nav.Link href="#product" className="site-footer__link px-0">
                Product
              </Nav.Link>
              <Nav.Link href="#how-it-works" className="site-footer__link px-0">
                How it Works
              </Nav.Link>
              <Nav.Link
                as="button"
                type="button"
                className="site-footer__link px-0"
                onClick={onBookDemo}
              >
                Book a Demo
              </Nav.Link>
            </Nav>
          </Col>
        </Row>

        <Row className="site-footer__bottom">
          <Col>
            <p className="site-footer__copy mb-0">
              © 2026 Lien Logic, Inc. All rights reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
